import { render } from "./PortfolioFooterSection.vue?vue&type=template&id=13a0475c&scoped=true"
import script from "./PortfolioFooterSection.vue?vue&type=script&lang=js"
export * from "./PortfolioFooterSection.vue?vue&type=script&lang=js"

import "./PortfolioFooterSection.vue?vue&type=style&index=0&id=13a0475c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13a0475c"],['__file',"src/scripts/view/portfolio/sections/PortfolioFooterSection.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "13a0475c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('13a0475c', __exports__)) {
    api.reload('13a0475c', __exports__)
  }
  
  module.hot.accept("./PortfolioFooterSection.vue?vue&type=template&id=13a0475c&scoped=true", () => {
    api.rerender('13a0475c', render)
  })

}


export default __exports__